import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';
import {
  SaveButtonId,
  SaveButtonStatus,
  SaveButtonStore,
} from '@macs-frontend/features/shared/components/save-button/save-button.store';

@Component({
  selector: 'md-save-button',
  templateUrl: 'save-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SaveButtonComponent extends BaseComponent implements OnInit {
  SaveButtonStatus = SaveButtonStatus;

  @Input()
  id: SaveButtonId = SaveButtonId.DEFAULT;

  @Input()
  isDirty = false;

  @Input()
  isNew = false;

  @Input()
  disabledButton = false;

  @Input()
  buttonType = 'button';

  // saving new object
  @Input()
  saveText = 'Save';

  // saving existent object
  @Input()
  saveChangesText = 'Save changes';

  @Input()
  doneText = 'Done';

  @Input()
  lightButton = false;

  @Output()
  save: EventEmitter<any> = new EventEmitter();

  saveButtonStatus = SaveButtonStatus;

  constructor(readonly cdr: ChangeDetectorRef, readonly store: SaveButtonStore) {
    super();
  }

  ngOnInit() {
    this.store.switchToDefault(this.id);
  }

  getButtonText(dirty: boolean, isNew: boolean, status?: SaveButtonStatus): string {
    if (!status) {
      // eslint-disable-next-line no-param-reassign
      status = SaveButtonStatus.DEFAULT;
    }
    switch (status) {
      case SaveButtonStatus.SAVING:
        return 'Saving';
      case SaveButtonStatus.SAVED:
        return 'Saved';
      case SaveButtonStatus.DEFAULT:
        if (isNew) {
          return this.saveText;
        } else {
          if (dirty) {
            return this.saveChangesText;
          } else {
            return this.doneText;
          }
        }
    }
  }

  getButtonClasses() {
    const classes = ['header__button', 'button'];
    if (this.lightButton) {
      classes.push('button_sm', 'button_white', 'underline', 'no-shadow');
    } else {
      classes.push('button_primary', 'text-uppercase');
    }

    return classes;
  }
}
